import { fg } from '@atlassian/jira-feature-gating';

const BoardHandleProjectWithoutBaseIssueType = {
	get(): boolean {
		return fg('scope-261_handle_project_without_l0_issue_type');
	},
};

export default BoardHandleProjectWithoutBaseIssueType;
